function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 48 40"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M48 4.735a19.235 19.235 0 01-5.655 1.59A10.076 10.076 0 0046.675.74a19.395 19.395 0 01-6.257 2.447C38.627 1.225 36.066 0 33.231 0c-5.435 0-9.844 4.521-9.844 10.098 0 .791.085 1.56.254 2.3C15.456 11.974 8.2 7.96 3.34 1.842a10.281 10.281 0 00-1.33 5.083c0 3.502 1.738 6.593 4.38 8.405a9.668 9.668 0 01-4.462-1.26v.124c0 4.894 3.395 8.977 7.903 9.901a9.39 9.39 0 01-2.595.356 9.523 9.523 0 01-1.854-.18c1.254 4.01 4.888 6.932 9.199 7.01-3.37 2.71-7.618 4.325-12.23 4.325-.795 0-1.58-.047-2.35-.139C4.359 38.327 9.537 40 15.096 40c18.115 0 28.019-15.385 28.019-28.73 0-.439-.009-.878-.026-1.308A20.211 20.211 0 0048 4.735",
  fillRule: "evenodd"
})));